import React, { ChangeEvent, ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MaxLengths } from '../../../../validation';
import styles from '../../../CreateIntegration/components/TagsForm/TagsForm.module.css';
import { TagsInput } from '../../../../components/Tags/TagsInput';
import TagSuggestions from '../../../../components/Tags/TagSuggestions';

export type TagsFormProps = {
  integrationToUpdate?: IntegrationToUpdate;
  allTags: Tag[];
  addTag: (tag: Tag) => void;
  setTags: (tags: Tag[]) => void;
  tagError: boolean;
  selectedTags: Tag[];
  setTagError: (value: boolean) => void;
};

export default function TagsForm({
  integrationToUpdate,
  allTags,
  addTag,
  setTags,
  tagError,
  selectedTags,
  setTagError,
}: TagsFormProps): ReactElement {
  const { t } = useTranslation();
  const [enteredText, setEnteredText] = useState('');
  const setText = (event: ChangeEvent<HTMLInputElement>) => {
    setEnteredText(event.target.value);
  };
  const isSuggestionsVisible = enteredText.length > 2 && !tagError;
  useEffect(() => {
    setEnteredText('');
  }, [integrationToUpdate?.tags, setEnteredText]);
  useEffect(() => {
    setTags(selectedTags);
  }, [selectedTags, setTags]);
  useEffect(() => {
    if (enteredText.length > MaxLengths.IntegrationTag) {
      setTagError(true);
    } else {
      setTagError(false);
    }
  }, [enteredText, setTagError]);
  return (
    <>
      <div className="half-margin">{t('tags.label')}</div>
      <div className="half-margin">
        <TagsInput
          enteredText={enteredText}
          tags={integrationToUpdate?.tags || []}
          setTags={setTags}
          setText={setText}
          error={tagError}
        />
      </div>
      {isSuggestionsVisible && (
        <TagSuggestions
          enteredText={enteredText}
          allTags={allTags}
          addTag={addTag}
          selectedTags={integrationToUpdate?.tags || []}
        />
      )}
      {tagError && (
        <div className={styles.maxLengthError}>
          {t('tags.errors.maxLength')}
        </div>
      )}
    </>
  );
}
